import { useEffect } from "react";
import { ArrayInput, Edit, SimpleForm, SimpleFormIterator, TextInput, useDataProvider, useNotify } from "react-admin";

export const McdnAppNameList = () => {
  const dataProvider = useDataProvider();
  useEffect(() => {
    dataProvider
      .getListMCDNAppNames()
      .then(({ data }) => {
        window.location.href = "/admin/#/mcdn-appname/" + data[0].id;
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return <></>;
};

export const McdnAppNameEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic">
      <SimpleForm>
        <ArrayInput source="values">
          <SimpleFormIterator>
            <TextInput label="Value" source="name" fullWidth />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};
